import { FormFieldNamesEnum } from './formFieldNamesEnum'

export const normalizers: { [key in FormFieldNamesEnum]?: (arg0: string) => string } = {
  [FormFieldNamesEnum.PostalCode]: val => {
    if (!val) { return '' }
    if (val.length > 5) { return val.substring(0, 5) }
    return val.replace(/\D/g, '')
  }
}
